import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Onboarding-6.css";
import Illustration from "../../../assets/Illustration.png";

export const Onboarding6 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userName = location.state?.userName || "Friend";

  const handleButton = () => {
    navigate("/Onboarding-Header5");
  };

  return (
    <div className="onboarding6-page-wrapper">
      {/* Centered Main Card Container */}
      <div className="onboarding6-main-card">
        {/* Title & Subtitle */}
        <div className="onboarding6-heading-group">
          <h1 className="onboarding6-page-title">
            Welcome Aboard, {userName}!
          </h1>
          <p className="onboarding6-page-subtitle">
            You’ve taken the first step. Now, let’s keep going.
          </p>
        </div>

        {/* Celebration Illustration */}
        <div className="onboarding6-illustration-container">
          <img
            src={Illustration}
            alt="Welcome Illustration"
            className="onboarding6-illustration-img"
          />
        </div>

        {/* Action Button */}
        <button
          type="button"
          className="onboarding6-continue-btn"
          onClick={handleButton}
        >
          Let’s Go
        </button>
      </div>
    </div>
  );
};

export default Onboarding6;
